import NoSyncStrategy from './NoSyncStrategy';

export default NoSyncStrategy;
